import React from "react";
import "./styles.css";

export default function Footer() {
  return (
    <h6 className="footer">
      <a
        href="https://github.com/Shahbi88/Weather-React-Separate-VS-import"
        target="_blank"
      >
        {" "}
        <span className="sig"> Open-source code </span>{" "}
      </a>
      by Rihab Azar
    </h6>
  );
}
